import { baseRequest } from "./base";

const getAllOrders = async (page, signal) => {
  var response = await baseRequest({
    url: `/api/orders?page=${page}`,
    method: "GET",
    signal: signal,
  });
  return response;
};

const getOrderById = async (id, signal) => {
  var response = await baseRequest({
    url: `/api/orders/${id}`,
    method: "GET",
    signal: signal,
  });
  return response;
};

const getSavedAddress = async (signal) => {
  var response = await baseRequest({
    url: `/api/get-address`,
    method: "GET",
    signal: signal,
  });
  return response;
};

const getDiscountCode = async (total, code) => {
  var response = await baseRequest({
    url: `/api/discount-code?total=${total}&discount_code=${code}`,
    method: "GET",
  });

  return response;
};

export { getAllOrders, getOrderById, getSavedAddress, getDiscountCode };
